module.exports = __webpack_public_path__ + "static/img/Marca Pais.12423109.png";